<template>
  <div>
    <div class="d-flex flex-column h-100 w-100">
      <div>
        <SystemBar />
      </div>
      <div class="d-flex align-center flex-fill overflow-auto px-5">
        <div class="text-center w-100">
          <div
            v-if="callingMessage.data.animation"
            class="mb-7"
          >
            <v-btn
              class="call-animation"
              color="primary"
              icon
              width="70px"
              height="70px"
            >
              <Icon
                class="icon-phone"
                color="#fff"
                icon="phone"
                :size="40"
              />
            </v-btn>
          </div>
          <div>
            {{ callingMessage.data.title }}
          </div>
          <div
            v-if="callingMessage.data.cancelable"
            class="mt-5"
          >
            <v-btn
              elevation="0"
              text
              outlined
              small
            >
              Cancelar llamada
            </v-btn>
          </div>
        </div>
      </div>
      <div>
        <OcularSign />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

require('@/plugins/OT')
require('@/services/Call')

@Component({
  components: {
    SystemBar: () => import(/* webpackPrefetch: true */ '@/components/SystemBar.vue'),
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    apiKeyVP8: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_VP8
    },
    apiKeyH264: {
      type: String,
      default: process.env.VUE_APP_OT_APIKEY_H264
    }
  },
  watch: {
    '$store.state.call.createCall.loading': function (loading) {
      if (!loading) {
        this.createSessionResponse()
      }
    },
    '$store.state.call.awaitingCammer.loading': function (loading) {
      if (!loading) {
        this.awaitCammerResponse()
      }
    }
  },
  computed: {
    linkSession () {
      return this.$store.state.linkSession
    },
    callingMessage () {
      return this.$organization.callingMessage()
    },
    widget () {
      return this.$store.state.widget
    }
  }
})
export default class Index extends Vue {
  async mounted () {
    if (this.widget.isBusy === true) {
      this.$router.replace({ path: '/is-busy' })
      return false
    }

    this.$store.commit('SET_ACTIVE_CALL', true)
    this.$tabsManager.callStarted()

    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Buscando agente',
      detail: 'El cliente está esperando ser atendido por un agente',
      actionType: 'STAH',
      functionality: 7,
      historyInteractionType: 'OSIFDV'
    })

    this.createSession()
  }

  errorHandler (error) {
    console.log(error)
  }

  saveAnalitycsEvent (detail, historyInteractionType) {
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action: 'Terminó el proceso de búsqueda',
      detail,
      actionType: 'STAH',
      functionality: 7,
      historyInteractionType
    })
  }

  ocGoogleAnalyticsInit() {
    OcGoogleAnalytics.getDataLayerConfig('init')
  }

  setCategoryId (categoryId) {
    if (!this.$store.state.storage.category) {
      this.$store.state.storage.category = { id: categoryId }
    } else {
      this.$store.state.storage.category.id = categoryId
    }

    return 'Success'
  }

  awaitCammerResponse () {
    const error = this.$store.state.call.awaitingCammer.error
    const res = this.$store.state.call.awaitingCammer.response
    if (error) {
      this.$store.commit('SET_ACTIVE_CALL', false)
      this.$tabsManager.callFinished()
      this.$storage.setState(1)
      this.$router.replace({ path: '/lobby' })
    } else if (res.statusCode === 0 && this.$store.state.testConnectivity.progress) {
      this.$storage.setState(7) // CALL ACTIVE
      this.$router.replace({ path: '/optimizing-resources' })
    } else if (res.statusCode === 0) {
      this.ocGoogleAnalyticsInit()
      this.saveAnalitycsEvent('La llamada del cliente fue atendida por un agente', 'OSSUCC')
      this.$storage.setStorageRoom(res.session)
      this.$storage.setState(4) // CALL ACTIVE
      this.$router.replace({ path: '/room', query: { fromCalling: true } })
    } else {
      this.$store.commit('SET_ACTIVE_CALL', false)
      this.$tabsManager.callFinished()
      this.saveAnalitycsEvent('El agente no contestó la llamada del cliente', 'OSNONV')
      this.$storage.setState(1)
      this.$router.replace({ path: '/lobby' })
    }
  }

  async awaitCammer () {
    this.$store.state.call.awaitingCammer.response = null
    this.$store.state.call.awaitingCammer.error = null
    this.$store.state.call.awaitingCammer.loading = true

    this.$call.awaitingCammer()
  }

  async createSessionResponse () {
    const error = this.$store.state.call.createCall.error
    const res = this.$store.state.call.createCall.response

    if (error) {
      this.$store.commit('SET_ACTIVE_CALL', false)
      this.$tabsManager.callFinished()

      this.$storage.setState(1) // PROGRESS
      if (this.$organization.totemMode().isActive) {
        this.$router.replace({ path: '/totem' })
      } else {
        this.$router.replace({ path: '/lobby' })
      }
    } else {
      if (res && res.statusCode === 0 || res.statusCode === 5) {
        this.$storage.setStorageRoom(res.session)
      }

      if (res && res.session && res.session.category_id) {
        this.setCategoryId(res.session.category_id)
      }

      if (res && res.statusCode === 0) {
        await this.awaitCammer()
      } else if (res && res.statusCode === 5) {
        this.saveAnalitycsEvent('El cliente ingresó a la fila de espera', 'QUEFIN')
        this.$storage.setState(3)
        this.$router.replace({ path: '/queue', query: { position: res.session.queuePosition } })
      } else if (res && res.statusCode === 1
        || res.statusCode === 2
        || res.statusCode === 3
        || res.statusCode === 4
        || res.statusCode === 6
        || res.statusCode === 9
        || res.statusCode === 15
      ) {
        this.$store.commit('SET_ACTIVE_CALL', false)
        this.$tabsManager.callFinished()
        this.$storage.setState(1) // PROGRESS
        this.$store.state.call.availableActions = res.available_actions || null

        if (res && res.statusCode === 9) {
          this.saveAnalitycsEvent('El cliente no pudo contactar un agente porque su dirección ip está bloqueada', 'OSNONV')
        } else {
          this.saveAnalitycsEvent('El cliente no pudo contactar con un agente', 'OSNONV')
        }

        if (this.$organization.totemMode().isActive) {
          this.$router.replace({ path: '/totem' })
        } else {
          this.$router.replace({ path: '/lobby' })
        }
      } else if (res && res.statusCode === 7) {
        this.$store.commit('SET_ACTIVE_CALL', false)
        this.$tabsManager.callFinished()
        this.$storage.setState(1) // PROGRESS
        this.$store.state.call.availableActions = res.available_actions || null
        this.saveAnalitycsEvent('El cliente llamó fuera del horario de atención', 'OSNONV')

        if (this.$organization.totemMode().isActive) {
          this.$router.replace({ path: '/totem' })
        } else {
          this.$router.replace({ path: '/lobby', query: { organizationSchedule: res.organizationSchedule } })
        }
      }
    }
  }

  async createSession () {
    const sessionId = this.linkSession ? this.linkSession.id : null

    this.$storage.setCodec('VP8')

    if (!this.$organization.totemMode().isActive) {
      this.$storage.setStorageRoom(null)
    }

    const category = this.$store.state.storage.category

    if (category && !category.uuid) {
      this.setCategoryId(null)
    }

    this.$storage.setState(2)

    this.$store.state.call.availableActions = null
    this.$store.state.call.createCall.response = null
    this.$store.state.call.createCall.error = null
    this.$store.state.call.createCall.loading = true
    this.$call.makeCall(sessionId)
  }
}
</script>
